function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7634 2.71232C12.7119 1.94839 11.2881 1.94839 10.2366 2.71232L2.89884 8.04356C1.84737 8.80749 1.4074 10.1616 1.80902 11.3977L4.61182 20.0238C5.01344 21.2598 6.16531 22.0967 7.46499 22.0967H16.535C17.8347 22.0967 18.9866 21.2598 19.3882 20.0238L22.191 11.3977C22.5926 10.1616 22.1526 8.80749 21.1012 8.04356L13.7634 2.71232ZM15.4271 7.6687L18.6984 10.94C18.9061 11.1477 18.9061 11.4697 18.6984 11.6774L15.4271 14.9383V12.342H11.2731V10.265H15.4271V7.6687ZM9.196 19.0923L5.92469 15.821C5.71699 15.6133 5.71699 15.2914 5.92469 15.0837L9.196 11.8228V14.419H13.3501V16.4961H9.196V19.0923Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=TaskTicket.js.map